module.exports = __webpack_public_path__ + "img/calendar.1009d6ee.svg";